/* eslint-disable react/require-default-props */
import { useCallback, useContext } from 'react';
import { FaUserCheck } from 'react-icons/fa';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../actions/auth-context';
import { deliveredOrderToClient } from '../../../../actions/order.service';

const DeliveredOrderToClientButton = ({ order, getOrders }) => {
  const { hasPermissions } = useContext(AuthContext);

  const deliveredOrder = useCallback(async (data) => {
    deliveredOrderToClient(data.id, {
      action_note: null,
    }).then(() => {
      getOrders();
    });
  }, []);

  return (
    <>
      {order.order_status === 'Recebido na unidade' &&
        hasPermissions(['edit_order', 'add_order']) && (
          <FaUserCheck
            size={22}
            className="mb-1 action"
            data-tip="Entregar pedido cliente"
            onClick={() => deliveredOrder(order)}
          />
        )}
    </>
  );
};

DeliveredOrderToClientButton.propTypes = {
  order: PropTypes.shape({
    order_status: PropTypes.string,
  }).isRequired,
  getOrders: PropTypes.func,
};

export default DeliveredOrderToClientButton;
